import { Component } from 'react'
import { graphql, compose } from 'react-apollo'

import { $ } from 'utils'
import { Loader } from 'components'
import { MATCH_FACE } from 'queries/matching'
import { withConsumer } from 'store'

import Results from './Results'

class MatchingFace extends Component {

  render() {
    const { closeBottomPanel, type, matchType, data: { loading, match, error, descriptor } } = this.props
    if (loading) return $(Loader)

    return (
      $(Results, { closeBottomPanel, type, matchType, results: match, source: descriptor, loading, error })
    )
  }
}

export default compose(
  graphql(MATCH_FACE, {
    options: props => ({
      variables: {
        fetchPolicy: 'cache-and-network',
        descriptorId: props.descriptorId,
        limit: +props.limit,
        listId: props.listId,
        descriptorIds: props.descriptorIds,
      }
    })
  })
)(withConsumer(MatchingFace, '/faces'))




// WEBPACK FOOTER //
// ./src/components/panels/MatchingResults/MatchingFace.js